import request from "@/http/request"

const  url = "TUserController"

/**
 * 查询所有学员信息(分页)
 * @param params
 */
export function getAllStudents(params) {
    return request({
        url: url+'/getAllStudents',
        method: 'get',
        params:params
    })

}

export function GetVerifyCode() {
    return request({
        url: url+'/GetVerifyCode',
        method: 'get'
    })

}




export function getAllEvaluator(params) {
    return request({
        url: url+'/getAllEvaluator',
        method: 'get',
        params:params
    })

}



export function getAllTeachers(params) {
    return request({
        url: url+'/getAllTeachers',
        method: 'get',
        params:params
    })

}



export function getAllVRStudents(params) {
    return request({
        url: url+'/getAllVRStudents',
        method: 'get',
        params:params
    })

}
export function getStudentInfo(params) {
    return request({
        url: url+'/getStudentInfo',
        method: 'post',
        data:params
    })

}




export function GetSendSMS(params) {
    return request({
        url:  url+'/GetSendSMS?phone='+params,
        method: 'get'
    })
}
/**
 * 查询所有学员信息
 * @param params
 */
export function getAllStudentsNoPage(params) {
    return request({
        url: url+'/getAllStudentsNoPage',
        method: 'get',
        params:params
    })

}

// jHLwtsnzN1G4a2CCvFP/oA==
/**
 * 注册用户
 * @param params
 */
export  function registerUser(params) {
    return request({
        url:url+"/register",
        method: 'post',
        data:params
    })
}

/**
 * 注册用户
 * @param params
 */
export  function TeacherRegister(params) {
    return request({
        url:url+"/TeacherRegister",
        method: 'post',
        data:params
    })
}




// 忘记密码
export  function updateregister(params) {
    return request({
        url:url+"/updateRegister",
        method: 'post',
        data:params
    })
}





/**
 * 更新用户
 * @param params
 */
export  function  updateUser(params) {
    return request({
        url:url+"/updateUser",
        method:"post",
        data: params
    })

}

/**
 * 删除用户
 * @param userId
 */
export function deleteUser(userId) {
    return request({
        url:url+"/deleteUser?userId="+userId,
        method:"delete"
    })
}


/**
 * 删除用户
 * @param userId
 */
export function DeleteWebsocket(userName) {
    return request({
        url:url+"/DeleteWebsocket?userName="+userName,
        method:"delete"
    })
}
/**
 * 重置密码
 * @param userId
 */
export function resetPassword(userId) {
    return request({
        url:url+"/resetPassword?userId="+userId,
        method:"put"
    })
}


/**
 * 通过当前登录用户获得用户信息
 */

export function getUserByLogin() {
    return request({
        url:url+"/getUserByLogin",
        method:"get"
    })
}




// WEBPACK FOOTER //
// ./src/api/user/userInfo.js